module.exports = __webpack_public_path__ + "img/history_icon.6e145547.svg";